<template>
  <button class="whatsapp-float-button" @click="openWhatsappContainer">
    <!-- <svg viewBox="0 0 80 80" class="circle-text">
      <defs>
        <path
          id="circlePath"
          d="M 40,40 m -33,0 a 33,33 0 1,1 66,0 a 33,33 0 1,1 -66,0"
        />
        <linearGradient id="textGradient" gradientTransform="rotate(90)">
          <stop stop-color="#176E3B" />
          <stop offset="0.242799" stop-color="#6BCBB3" />
          <stop offset="0.485597" stop-color="#176E3B" />
          <stop offset="0.742799" stop-color="#419C77" />
          <stop offset="1" stop-color="#6BCBB3" />
        </linearGradient>
      </defs>
      <text fill="url(#textGradient)" font-size="8.5" font-weight="300">
        <textPath xlink:href="#circlePath">
          Contact us now&nbsp;&nbsp; Contact us now&nbsp;&nbsp; Contact us now
        </textPath>
      </text>
    </svg> -->
    <!-- <div class="center-circle">
      <NuxtImg
        v-no-right-click
        src="https://tw028jd0.turpal.com/assets/GetThatBoat/bald-man-support.svg"
        alt="Support"
      />
    </div> -->
    <icon-whatsapp class="base-icon text-heading-2 text-white w-5 h-5" />
    <span>
      {{ t("whatsapp.title") }}
    </span>
  </button>
</template>
<script setup lang="ts">
import { useRuntimeConfig } from "nuxt/app";

const { t } = useI18n();
const config = useRuntimeConfig() as unknown as RuntimeConfiguration;

const openWhatsappContainer = () => {
  window.open(`https://wa.me/${config.public.whatsapp}`, "_blank");
};
</script>
<!-- <style scoperd lang="scss">
.support-float-button {
  position: fixed;
  bottom: 14px;
  right: 14px;
  width: 100px;
  height: 100px;
  z-index: 10;
  cursor: pointer;
  @media screen and (min-width: 1440px) {
    right: 30px;
    bottom: 30px;
  }
}
.support-float-button:hover {
  & .center-circle {
    box-shadow: 0px 2px 8px rgba(107, 110, 128, 0.3);
  }
  & .center-circle img {
    transform: scale(1.025);
  }
}
.support-float-button .circle-text {
  width: 100%;
  height: 100%;
  animation: rotateText 14s linear infinite;
}
.support-float-button .center-circle {
  width: 66px;
  height: 66px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 17px;
  left: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  pointer-events: none;
  fill: #fff;
  box-shadow: 0px 2px 8px rgba(107, 110, 128, 0.1);
  transition: all 0.3s ease;
}
.support-float-button .center-circle img {
  width: 40px;
  height: 40px;
  transition: transform 0.3s ease;
  will-change: transform;
  backface-visibility: hidden;
  image-rendering: -webkit-optimize-contrast;
}

@keyframes rotateText {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style> -->

<style scoped lang="scss">
.whatsapp-float-button {
  @apply fixed ltr:right-5 rtl:left-5 md:ltr:right-6 md:rtl:left-6 bottom-5 px-2 py-2 cursor-pointer flex items-center gap-1 z-10 rounded-[10px];
  background: linear-gradient(106.85deg, #67ec6f 15.15%, #00a014 81.18%);

  & span {
    @apply text-heading-6 text-white max-md:hidden font-bold;
  }
}
</style>
